module.exports = "/_next/static/chunks/images/person-driving-car-e18c83c4990ecb58eea2ff49a4056b52.jpg";